import { NextPage } from "next";
import { useSelectSlice } from "@common/redux/selectors/useSelectSlice";
import { recommendationSlice } from "@common/redux/slices/recommendation.slice";
import { Layout } from "@kursk/components/Layout/Layout";
import { HeaderBlock } from "@kursk/components/ui/HeaderBlock/HeaderBlock";
import { ContentBlock } from "@kursk/components/ui/ContentBlock/ContentBlock";
import styles from "./SingleRestaurant.module.scss";
import { SocialLinks } from "@kursk/components/ui/SocialLinks/SocialLinks";
import { Tags } from "@kursk/components/ui/Tags/Tags";
import { ContactsBlock } from "@kursk/components/ui/ContactsBlock/ContactsBlock";
import { NotFoundPage } from "@kursk/components/pages/404/NotFoundPage";
import React from "react";
import { restaurantsListSlice } from "@common/redux/slices/restaurants.slice";
import { RecommendationsBlock } from "@kursk/components/ui/RecommendationsBlock/RecommendationsBlock";
import { Socials } from "@kursk/components/pages/Home/Socials/Socials";
import { SeoMetaTitles } from "@kursk/components/seo/SeoMetaTitles";
import { getAddress } from "@kursk/utils/getAddress";
import { LdJson } from "@kursk/components/seo/LdJson";
import { FeedbacksBlock } from "@kursk/components/ui/FeedbacksBlock/FeedbacksBlock";
import { themeValue } from "@kursk/themes";

export const SingleRestaurant: NextPage = () => {
  const { restaurant } = useSelectSlice(restaurantsListSlice);
  const { forRestaurantsRestaurants, forRestaurantsPlacesNear } = useSelectSlice(recommendationSlice);

  return (
    <>
      {restaurant ?
        <Layout key={`restaurant_${restaurant._id}`}>
          <LdJson
            entity={restaurant}
            type={'restaurants'}
          />
          <SeoMetaTitles page="singleRestaurant" entity={{
            name: restaurant.name,
            seo: restaurant.seo,
            address: getAddress(restaurant.address),
            image: restaurant.image,
          }} showOgImage={true}/>
          <section className={styles.entity_header}>
            <HeaderBlock
              entityType={'restaurants'}
              entity={restaurant}
              goBack={'/restaurants'}
              goBackTitle={'вернуться к списку ресторанов'}
              customBuyButton={themeValue({
                vladimir: <div></div>,
                default: null,
              })}
            />
          </section>
          <section className={styles.entity_share}>
            <SocialLinks/>
          </section>
          <section className={styles.entity_content}>
            <ContentBlock content={restaurant.content} source={restaurant?.source} />
          </section>
          <section className={styles.entity_contacs}>
            <ContactsBlock entity={restaurant}/>
          </section>
          <section className={styles.entity_tags}>
            <Tags link={'/restaurants'} className={styles.tags} tags={restaurant?.tags}/>
          </section>
          <section className={styles.entity_feedbacks}>
            <FeedbacksBlock entity={restaurant} entityType={'restaurants'}/>
          </section>
          <section className={styles.entity_recommendations}>
            <RecommendationsBlock
              entityType="places"
              data={forRestaurantsPlacesNear}
              title={'рядом находится'}
              goTo={'/places'}
              goToTitle={'все места'}/>
          </section>
          <section className={styles.entity_recommendations}>
            {
              forRestaurantsRestaurants.map(restaurant => {
                return <LdJson
                  key={restaurant._id}
                  entity={restaurant}
                  type={'restaurants'}
                />
              })
            }
            <RecommendationsBlock
              entityType="restaurants"
              data={forRestaurantsRestaurants}
              title={'также рекомендуем'}
              goTo={'/restaurants'}
              goToTitle={'все рестораны'}/>
          </section>
          <section className={styles.entity_social}>
            <Socials/>
          </section>
        </Layout>
        : <NotFoundPage/>}
    </>
  )
}
